import styled from 'styled-components';
import { KiperButton } from '@kiper/ui';
import { getInviteBrandColors } from '../brandColors';
import { OPEN_STATUS } from './settings';

const feedbackColors = theme => ({
  [OPEN_STATUS.SUCCESS]: {
    background: theme.colors.semantic.status.success,
    color: theme.colors.success500,
  },
  [OPEN_STATUS.ERROR]: {
    background: theme.colors.semantic.status.danger,
    color: theme.colors.danger500,
  },
});

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  padding: 24px 16px;
  background: ${({ theme, $variant }) =>
    getInviteBrandColors($variant, theme).primary};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 440px;
`;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 8px;
  padding: 0;
  border: none;
  background: none;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.semantic.text.inverse};
  cursor: pointer;

  &:focus {
    outline: 0;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.semantic.surface.card};
  box-shadow: ${({ theme }) => theme.colors.semantic.shadow.sm};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const HeaderIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.semantic.surface.muted};
  color: ${({ theme, $variant }) =>
    getInviteBrandColors($variant, theme).secondary};
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
`;

export const Period = styled.span`
  display: flex;
  flex-direction: column;
`;

export const Feedback = styled.p`
  margin: 0;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
  ${({ theme, $status }) => `
    background: ${feedbackColors(theme)[$status].background};
    color: ${feedbackColors(theme)[$status].color};
  `}
`;

export const OpenButton = styled(KiperButton)`
  && {
    border-color: ${({ theme, $variant }) =>
      getInviteBrandColors($variant, theme).secondary};
    background-color: ${({ theme, $variant }) =>
      getInviteBrandColors($variant, theme).secondary};
  }

  &&:hover {
    opacity: 0.88;
  }
`;
